module.exports = "<span data-ng-message=required>*required</span> <span data-ng-message=pattern>*Only US date format ('mm/dd/yyyy') allowed</span>";